import React from 'react';
import { Button } from '@mui/material';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import { InCallParticipant } from '../types/consultationPage.types';
import { FALLBACK_AVATAR, formatWaitingDuration } from '../utils/consultationHelpers';
import styles from '../styles.module.scss';

type Props = {
  participants: InCallParticipant[];
  onJoin: () => void;
};

const InCallSection = ({ participants, onJoin }: Props): JSX.Element => {
  return (
    <div className={styles.consultationPageRightSideFrameInCall}>
      <div className={styles.consultationPageRightSideFrameInCallDiv}>
        <span className={styles.consultationPageRightSideFrameInCallText}>In call</span>
        <span className={styles.consultationPageRightSideFrameInCallnumber}>{participants.length}</span>
      </div>

      {participants.length === 0 ? (
        <div className={styles.consultationPageRightSideFrameInCallEmptyState}>
          <span>No one has joined the call yet.</span>
        </div>
      ) : (
        <div className={styles.consultationPageRightSideFrameInCallParticipantsList}>
          {participants.map((participant) => (
            <div key={String(participant.id)} className={styles.consultationPageRightSideFrameInCallParticipants}>
              <img
                alt={participant.name}
                className="fs-exclude"
                src={participant.avatar}
                onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
                  const img = event.currentTarget;
                  img.src = FALLBACK_AVATAR;
                  img.onerror = null;
                }}
              />

              <div className={styles.consultationPageRightSideFrameInCallParticipantsInformation}>
                {participant.role ? (
                  <span className={styles.consultationPageRightSideFrameInCallParticipantsInformationRole}>
                    {participant.role}
                  </span>
                ) : null}

                <span className={styles.consultationPageRightSideFrameInCallParticipantsInformationName}>
                  {participant.name}
                </span>

                <span className={styles.consultationPageRightSideFrameInCallParticipantsInformationWaitingDuration}>
                  {formatWaitingDuration(participant.duration)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      <Button variant="contained" color="primary" onClick={onJoin}>
        <VideocamOutlinedIcon />
        Join video call
      </Button>
    </div>
  );
};

export default InCallSection;